import { tabCloser, tabTemplate, categoryTab } from '@/layout/state/state';
import { matchSingleUrl } from '@/constants/urls';
import { closeRequests } from '../actions';
import RequestsActions from '../components/RequestsActions';
import RequestsPanel from '../components/RequestsPanel';

export default {
  ...tabTemplate('requests', RequestsPanel, matchSingleUrl(['requests']), RequestsActions),
  ...tabCloser('closeRequestsTab', closeRequests),
  access: ({ requests }) => requests.read,
  componentState: ({ url }) => categoryTab(url, 'all'),
  dropDownIcon: 'list alternate',
  icon: 'fas fa-list-alt',
  order: 500,
};
